import(/* webpackMode: "eager" */ "/vercel/path0/app/features/page.jsx");
